import React from "react";
import { Row, Col, Button } from "reactstrap";
import ItemCounter from "../ItemCounter";
import { useSelector } from "react-redux";

const CartActionsSection = ({
  selectedItem,
  setSelectedItem,
  addToCart,
  loading,
}) => {
  const { color } = useSelector((state) => state.global);

  const handleQuantityChange = (newQuantity) => {
    setSelectedItem((prev) => {
      const addonsTotal =
        prev.addons?.reduce(
          (sum, addon) => sum + addon.price * addon.quantity,
          0
        ) || 0;

      return {
        ...prev,
        quantity: newQuantity,
        totalPrice: Number(prev.price) * newQuantity + addonsTotal,
      };
    });
  };

  const isButtonDisabled = !selectedItem.size || selectedItem.quantity < 1;
  const totalPriceDisplay = selectedItem?.totalPrice;
  const currency = selectedItem.currency || "";

  return (
    <Row className="mx-2 my-4">
      <Col xs={12} className="d-flex flex-column align-items-center">
        <ItemCounter
          selectedItem={selectedItem}
          setSelectedItemsSize={handleQuantityChange}
        />

        <Button
          style={{ backgroundColor: color }}
          className="top_cards__addtocart fs--16 fw--500 my-4 w-100"
          onClick={addToCart}
          disabled={isButtonDisabled || loading}
        >
          {isButtonDisabled
            ? "Select size to add to cart"
            : `Add to cart - ${currency || "$"}${totalPriceDisplay}`}
        </Button>
      </Col>
    </Row>
  );
};

export default CartActionsSection;
